import { useConfig } from '@gaming1/g1-config';

export const useUniformizationGiftsDesign = () =>
  useConfig().betting.uniformizationGiftsDesign;
